define('OutSystems/ReactWidgets/Popover',["require", "exports", "tslib", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Popover = void 0;
    var Popover = (function (_super) {
        tslib_1.__extends(Popover, _super);
        function Popover(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.bottomPlaceholderRef = React.createRef();
            _this.outerOnClickHander = function (event) {
                if (!_this.isElementInsidePopover(event.target)) {
                    _this.unregisterOuterOnClickEvent();
                    _this.setState({
                        expanded: false,
                    });
                }
            };
            _this.state = {
                expanded: false,
            };
            return _this;
        }
        Popover.prototype.show = function (event) {
            event.stopPropagation();
            this.registerOuterOnClickEvent();
            this.setState({
                expanded: true,
            });
        };
        Popover.prototype.hide = function (event) {
            event.stopPropagation();
            this.setState({
                expanded: false,
            });
        };
        Popover.prototype.registerOuterOnClickEvent = function () {
            document.addEventListener("click", this.outerOnClickHander, { capture: true });
        };
        Popover.prototype.unregisterOuterOnClickEvent = function () {
            document.removeEventListener("click", this.outerOnClickHander, { capture: true });
        };
        Popover.prototype.isElementInsidePopover = function (element) {
            var popover = this.getHTMLNode();
            return element && (element === popover || popover.contains(element));
        };
        Popover.prototype.adjustPositionBasedOnViewport = function () {
            if (this.state.expanded) {
                var popoverBottom = this.bottomPlaceholderRef.current;
                var transform = "";
                var boundingRect = popoverBottom.getBoundingClientRect();
                if (boundingRect.left < 0) {
                    transform = "translateX(0)";
                    popoverBottom.style.left = "0px";
                    popoverBottom.style.marginLeft = "0px";
                }
                else if (boundingRect.right > window.innerWidth) {
                    transform = "translateX(0)";
                    popoverBottom.style.left = "";
                    popoverBottom.style.right = "0px";
                }
                else {
                    transform = "translateX(-50%)";
                }
                if (boundingRect.bottom > window.innerHeight) {
                    transform += " translateY(-100%)";
                    popoverBottom.style.marginTop = "20px";
                }
                popoverBottom.style.transform = transform;
                popoverBottom.style.webkitTransform = transform;
            }
        };
        Popover.prototype.componentDidUpdate = function () {
            this.adjustPositionBasedOnViewport();
        };
        Popover.prototype.componentDidMount = function () {
            this.adjustPositionBasedOnViewport();
        };
        Popover.prototype.componentWillUnmount = function () {
            this.unregisterOuterOnClickEvent();
        };
        Popover.prototype.preparePopoverAttributes = function () {
            var popoverAttributes = {
                "data-popover": "",
                className: this.props.style,
            };
            this.fillWithBuiltinProperties(popoverAttributes);
            if (this.state.expanded) {
                popoverAttributes.className += " popover-expanded";
            }
            return popoverAttributes;
        };
        Popover.prototype.preparePopoverTopPlaceholderAttributes = function () {
            var _this = this;
            var popoverTopAttributes = {
                className: "popover-top",
                onClick: function (event) { return _this.show(event); },
            };
            return popoverTopAttributes;
        };
        Popover.prototype.preparePopoverBottomPlaceholderAttributes = function () {
            var _this = this;
            var popoverStyle = {
                width: this.props.popoverWidth ? this.props.popoverWidth + "px" : "",
            };
            var popoverBottomAttributes = {
                className: "popover-bottom ",
                onClick: function (event) { return _this.hide(event); },
                style: popoverStyle,
                ref: this.bottomPlaceholderRef,
            };
            return popoverBottomAttributes;
        };
        Popover.prototype.render = function () {
            var topContent = (React.createElement("div", tslib_1.__assign({}, this.preparePopoverTopPlaceholderAttributes()), this.props.placeholders.topContent.render()));
            var bottomContent = this.state.expanded ? (React.createElement("div", tslib_1.__assign({}, this.preparePopoverBottomPlaceholderAttributes()), this.props.placeholders.bottomContent.render())) : null;
            return (React.createElement("div", tslib_1.__assign({}, this.preparePopoverAttributes()),
                topContent,
                bottomContent));
        };
        Popover = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Popover);
        return Popover;
    }(Widget_1.Widget));
    exports.Popover = Popover;
});
//# sourceMappingURL=Popover.js.map;
